module.exports = __webpack_public_path__ + "img/Rookie-5.2242674e.png";